<div style="overflow: auto; height: calc(100vh - 54px);">
    <section id="headline" style="background-image: url('public/module/banniere_store_1296x729.png'); background-repeat: repeat; background-position: top left;">
        <div class="container py-11">
            <div class="row">
                <div>
                    <div class="headline-content py-lg-2">
                        <h1>Virtual School</h1>
                        <p class="subhealine">La première plateforme numérique universitaire et secondaire qui comprend votre parcours
                            et besoins</p>
                        <p class="text-center"><a class="btn"
                                href="https://play.google.com/store/apps/details?id=com.enovsky.virtualschool"><img
                                    src="assets/logos/google_play.svg" width="200" draggable="false"></a>
                            <a class="btn" href="https://apps.apple.com/us/app/virtual-school/id6743828756"><img
                                    src="assets/logos/apple_logo.svg" width="200" draggable="false"></a>
                        </p>
                    </div>
                </div>
                <div class="download-container">
                    <div class="download-card">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 88 88"><path fill="#0078D4" d="M0 12.54L35.76 7v35.23H0V12.54zM39.69 6.4L88 0v42.21H39.69V6.4zM0 45.79h35.76V81L0 75.54V45.79zm39.69-.14H88V88l-48.31-6.82V45.65z"/></svg>
                        <h3>Windows</h3>
                        <p>Téléchargez et installez le format .exe sur Windows 10 / 11</p>
                        <a href="https://ndapi.master.enovsky.com/Virtual%20School%20(Windows).exe" download>Télécharger</a>
                    </div>

                    <div class="download-card">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 17"><path fill="#000" d="M13.99 13.16c-.36.81-.53 1.16-1 1.88-.65 1.02-1.57 2.29-2.71 2.31-1.01.02-1.27-.66-2.64-.66-1.38 0-1.66.64-2.65.68-1.07.04-1.89-1.11-2.54-2.12-1.73-2.64-1.91-5.75-.85-7.41.76-1.19 2.11-1.88 3.34-1.88 1.25 0 2.04.64 3.07.64 1 0 1.6-.64 3.07-.64 1.1 0 2.26.6 3 1.64-2.64 1.45-2.21 5.27.92 6.56zM9.5 0c.2 1.47-.71 3.01-1.6 3.97-.9.95-2.34 1.68-3.58 1.59C4.1 4.1 4.85 2.48 5.7 1.55 6.55.63 8.07-.18 9.5 0z"/></svg>
                        <h3>macOS</h3>
                        <p>Téléchargez et installez le format .dmg sur MacOS (à partir de Monterey)</p>
                        <a href="https://ndapi.master.enovsky.com/Virtual%20School%20(MacOS).dmg" download>Télécharger</a>
                    </div>

                    <div class="download-card">
                        <!-- Icône globe pour "En ligne" -->
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="64" height="64">
                            <circle cx="32" cy="32" r="32" fill="#4CAF50"/>
                            <path fill="#fff" d="M32 12a20 20 0 100 40 20 20 0 000-40zm0 2c2.7 0 5.2.7 7.4 1.9-1.3 1.7-2.5 4.1-3.4 7.1H28c-.9-3-2.1-5.4-3.4-7.1A18.02 18.02 0 0132 14zm-8.6 3.4c1.6 2 2.9 4.9 3.7 8.6H17.2a18.03 18.03 0 016.2-8.6zM14 32c0-2.1.3-4.1.9-6h11.2c.2 2 .4 4 .4 6s-.2 4-.4 6H14.9c-.6-1.9-.9-3.9-.9-6zm3.2 10h9.9c-.8 3.7-2.1 6.6-3.7 8.6a18.03 18.03 0 01-6.2-8.6zM32 50a18.02 18.02 0 01-7.4-1.9c1.3-1.7 2.5-4.1 3.4-7.1h8c.9 3 2.1 5.4 3.4 7.1A18.02 18.02 0 0132 50zm8.6-3.4c-1.6-2-2.9-4.9-3.7-8.6h9.9a18.03 18.03 0 01-6.2 8.6zM37.6 38c-.2-2-.4-4-.4-6s.2-4 .4-6h11.2c.6 1.9.9 3.9.9 6s-.3 4.1-.9 6H37.6zm-1.4-14c.8-3.7 2.1-6.6 3.7-8.6a18.03 18.03 0 016.2 8.6H36.2z"/>
                        </svg>
                        <h3>En ligne</h3>
                        <p>Accédez à Virtual School directement depuis votre navigateur</p>
                        <a href="https://virtualschool.enovsky.com">Aller à</a>
                    </div>
                </div>
                
            </div>
            
        </div>
        <div class="social-network-container">
            <div class="social-network-card" style="background-color: white;">
                <div style="color: black; padding-bottom: 5px;">Suivez-nous sur:</div>
                <div>
                    <a href="https://www.tiktok.com/@enovsky_official"><img src="https://ndapi.master.enovsky.com/images/tik-tok.png" alt="tiktok" width="35" style="margin:0 10px;"/></a>
                    <a href="https://www.instagram.com/enovsky_official"><img src="https://ndapi.master.enovsky.com/images/instagram.png" alt="instagram" width="35" style="margin:0 10px;"/></a>
                    <a href="https://www.linkedin.com/company/enovsky"><img src="https://ndapi.master.enovsky.com/images/linkedin.png" alt="linkedin" width="35" style="margin:0 10px;"/></a>
                    <a href="https://twitter.com/_JMKD_"><img src="https://ndapi.master.enovsky.com/images/twitter.png" alt="twitter" width="35" style="margin:0 10px;"/></a>
                    <a href="https://www.facebook.com/enovsky"><img src="https://ndapi.master.enovsky.com/images/facebook.png" alt="facebook" width="35" style="margin:0 10px;"/></a>
                </div>
            
            </div>

        </div>
    </section>

    <div id="main" class="site-main">
        <section id="who_we_are" class="py-6">
            <div class="container text-center">
                <div class="row mb-7">
                    <h2 class="section-title mb-7">Qui sommes-nous ?</h2>
                    <div style="max-width: 875px; margin: auto;">
                        <p>ENOVSKY - Une société basée au Togo qui a mis en place le projet Virtual School pour
                            révolutionner la méthode d'apprentissage des étudiants grâce à l'utilisation des méthodes de
                            l'intelligence artificielle d'extraction de contenus textuels. Nous proposons des contenus
                            spécifiques du parcours des étudiants.</p>
                    </div>
                </div>
                <div fxLayout="row wrap" fxLayout.xs="column">
                    <div fxFlex="33.33">
                        <div class="icon" style="color: #fff; font-size: 3em; text-align: center;">
                            <i class="fas fa-folder-open gradient-icon"></i>
                        </div>
                        <h3>Accès aux Contenus des Modules</h3>
                        <p>Nous assurons la persistance de tous vos contenus (Examens, Devoirs, Contrôles continus,
                            Exercises, Travaux Dirigés, Cours, Vidéos, ...) de votre parcours afin de vous limiter le
                            manque d'accès.</p>
                    </div>
                    <div fxFlex="33.33">
                        <div class="icon" style="color: #fff; font-size: 3em; text-align: center;">
                            <i class="fas fa-folder-plus gradient-icon"></i>
                        </div>
                        <h3>Recommandation</h3>
                        <p>Nous nous basons sur vos préférences pour vous recommander grace à l'intelligence
                            artificielle des modules pertinents.</p>
                    </div>
                    <div fxFlex="33.33">
                        <div class="icon" style="color: #fff; font-size: 3em; text-align: center;">
                            <i class="fas fa-arrow-up-right-dots gradient-icon"></i>
                        </div>
                        <h3>No Limit</h3>
                        <p>En plus des contenus de votre parcours vous pouvez vous inscrire à des modules présents dans
                            d'autres facultés pour approfondir vos connaissance ou pour en faire votre UE Libre.</p>
                    </div>
                </div>
            </div>
        </section>
        <section id="ower_solutions" class="py-6" style="background-color: white;">
            <div class="container">
                <div class="row">
                    <div class="text-center mb-5">
                        <h2 class="section-title">Pourquoi Virtual School ?</h2>
                        <p></p>
                    </div>
                </div>
                <div fxLayout="row wrap" fxLayout.xs="column">
                    <div id="why-challenges" class="col-lg-5 d-flex align-items-center">
                        <div class="w-100">
                            <h3>Problèmes des étudiants</h3>
                            <div class="why-item">
                                <h4>Problème d'accès aux contenus sur l'historique des Ecoles et Universités</h4>
                                <p>Difficultés des étudiants à trouver des anciennes épreuves.</p>
                            </div>
                            <div class="why-item">
                                <h4>Coût d'accès aux contenus élevés</h4>
                                <p>Les étudiants sont obligés de faire des dépenses dans les photocopies, travaux
                                    dirigés et fascicules payants.</p>
                            </div>
                            <div class="why-item">
                                <h4>Difficultés d'accès continuel à l'internet</h4>
                                <p>Beaucoup d'étudiants n'ont pas de wifi à domicile pour continuer à avoir accès aux
                                    contenus en ligne, problème de connexion.</p>
                            </div>
                            <div class="why-item">
                                <h4>Difficulté de travailler en groupe</h4>
                                <p>Les étudiants ont du mal à créer des liens de groupe favorisant le travaille de groupe.</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-2 text-center d-flex align-items-center">
                        <div class="w-100 text-center">
                            <img style="width: 260px; margin: 2rem 0 3rem;" src="public/module/bg-reasons.png">
                        </div>
                    </div>
                    <div id="why-solutions" class="col-lg-5 text-end d-flex align-items-center justify-content-md-end">
                        <div class="w-md-80 w-100">
                            <h3>Solutions de Virtual School</h3>
                            <div class="why-item">
                                <h4>Assistance IA Personnalisée</h4>
                                <p>Un Moteur d'IA Avancé d'assistance personnalisée. Une aide précieuse pour la résolution de problèmes académiques.</p>
                            </div>
                            <div class="why-item">
                                <h4>Outil Collaboratif: VirtualChat</h4>
                                <p>Créer et gérer facilement des groupes de travail, cet outil intégré favorise le travail en groupe entre étudiants.</p>
                            </div>
                            <div class="why-item">
                                <h4>Nous assurons l'accès à des contenus anciens comme nouveaux</h4>
                                <p>Les étudiants pourront avoir un accès facile à des contenus de leurs départements.
                                </p>
                            </div>
                            <div class="why-item">
                                <h4>Avec Virtual School, nous divisons le coût de vos photocopies drastiquement.</h4>
                                <p>Avec un coût assez bas, vous avez meme accès à des contenus des modules des autres
                                    départements en étant écologique.</p>
                            </div>
                            <div class="why-item">
                                <h4>Accès en mode hors connexion</h4>
                                <p>Nous avons pensé à la réalité des étudiants, tous les contenus sont accessibles en
                                    hors connexion dès qu'ils sont chargés.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section id="functionality" style="padding: 20px;">
            <div class="container">
                <div fxLayout="row wrap" fxLayout.xs="column">
                    <div fxFlex="50" style="min-width: 470px;">
                        <style>
                            .superposition {
                                position: relative;
                                width: 100%;
                                height: 100%;
                                padding-top: 100%;
                            }

                            /* on personnalise la position de la seconde image */
                            .superposition>div {
                                position: absolute;
                                width: 50%;
                                height: 100%;
                                top: 0;
                            }

                            .superposition>div>img {
                                width: 100%;
                            }

                            .image-2 {
                                left: 50%;
                            }

                            .superposition img {
                                height: 100%;
                                max-width: 100%;
                            }
                        </style>
                        <figure class="superposition">
                            <div>
                                <img src="assets/images/content_view.png" class="img-fluid" alt="Qui-sommes-Nous"
                                    draggable="false">
                            </div>
                            <div class="image-2">
                                <img src="assets/images/acceuil_view.png" class="img-fluid" alt="Qui-sommes-Nous"
                                    draggable="false">
                            </div>
                        </figure>

                    </div>
                    <div fxFlex="50" style="min-width: 470px;">
                        <div>
                            <h2 class="section-title text-center">Fonctionnalités</h2>
                            <ul class="mb-3" style="list-style: none;">
                                <li>- Intuitive et facile d'utilisation avec des accès rapides,</li><br>
                                <li>- 100 % accessible en mode offline (sans connexion),</li><br>
                                <li>- Synchronisation temps réel en mode online,</li><br>
                                <li>- Sauvegarde d'état continue (Vous reprenez où vous l'avez laissé),</li><br>
                                <li>- Recommandation de nouveaux contenus.</li><br>
                            </ul>
                            <p class="text-center"><a class="btn"
                                    href="https://play.google.com/store/apps/details?id=com.enovsky.virtualschool"><img
                                        src="assets/logos/google_play.svg" width="200" draggable="false"></a>
                                <a class="btn"
                                    href="https://apps.apple.com/us/app/virtual-school/id6743828756"><img
                                        src="assets/logos/apple_logo.svg" width="200" draggable="false"></a>
                            </p>
                            <div class="text-center"><button class="btn btn-primary" type="button" id="demobtn" (click)="playDemo()">Play demo</button></div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
    <section id="footer" style="padding: 20px;">
        <div class="container">
            <div fxLayout="row wrap" fxLayout.xs="column">
                <div class="col-lg-4 mb-4 mb-lg-0">
                    <div class="footer-box">
                        <h4>ENOVSKY</h4>
                        <ul>
                            <li><a href="#"><i class="fas fa-location-dot"></i> Villepinte, 93420 - France</a></li>
                            <li><a href="tel:+33 9 55 60 24 26"><i class="fas fa-phone"></i> +33 9 55 60 24 26</a></li>
                            <li><a href="#"><i class="fas fa-envelope"></i> contact@enovsky.com</a></li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-4 mb-4 mb-lg-0">
                    <div class="footer-box">
                        <h4>Nos Partenaires</h4>
                        <div class="row">
                            <div class="col-sm-6 mb-3 mb-sm-0">
                                <ul>
                                    <li><a href="https://www.facebook.com/CDGenie/"><img
                                                src="assets/images/ces_du_genie.png" width="100" draggable="false"></a>
                                    </li>
                                    <li><a href="#">Afrik Apps Home</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="footer-box">
                        <h4>Newsletter</h4>
                        <p>Restez informé sur les évènements ENOVSKY</p>
                        <div id="newsletter">
                            <form action="#">
                                <div class="input-group">
                                    <input type="text" class="form-control" name="email"
                                        placeholder="Votre adresse mail ici">
                                    <div class="input-group-btn">
                                        <a href="#" class="btn btn-default"><i class="fas fa-arrow-right fa-1x"></i></a>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div style="height: 20px;"></div>
            <div id="copyright" fxLayout="row wrap">
                <div class="col-lg-6 footer-social mb-5 text-center text-lg-end order-lg-2">
                    
                </div>
                <div class="col-lg-6 text-center text-lg-start">
                    <p class="pt-2"><small>Copyright © 2022-{{currentYear}} <a href="/" title="ENOVSKY" rel="home">ENOVSKY</a>. Tous
                            droits réservés.<span class="d-none d-md-inline"> | </span><a class="d-block d-md-inline"
                                href="https://enovsky.com/policy">Politique &amp; Conditions d'Utilisation</a></small>
                    </p>
                </div>
            </div>
        </div>
    </section>
</div>
